// extracted by mini-css-extract-plugin
export default {"cursor":"#ffb400"};